<template>
    <span>
        {{ value ? 'Ja' : 'Nee' }}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ]
}
</script>
